import { NgModule } from '@angular/core';

import { IconComponent } from './icon.component';

/**
 *  @deprecated use IconComponent
 */
@NgModule({
  imports: [IconComponent],
  exports: [IconComponent],
})
export class IconModule {}

export { IconComponent, IconSize, IconSizes, IconColor } from './icon.component';
